export const breakTiny = '320px';
export const breakSmall = '812px';
export const breakMedium = '1024px';
export const breakLarge = '1280px';
